import MotorParseable from "./class.MotorParseable";

export default class DragDropMathjax extends MotorParseable {
	isClearButtonEnabled() {
		return this.clearButtonIsEnabled;
	}

	constructor(options) {
		super(options);
		this.clearButtonIsEnabled = false;
	}

	getNewDriver() {
		return new Motors.Drivers.DragDropMathjaxDriver();
	}

	getStartSignal() {
		let draggableInEachDropArea =
			this.driverOutputs.draggableInEachDropArea ||
			this.tryJSONParse(this.model.draggableInEachDropArea) ||
			[];

		return {
			mathjax: this.model.mathjax,
			draggableContents: this.tryJSONParse(this.model.draggableContents),
			areDraggablesReusable: this.model.areDraggablesReusable,
			draggableInEachDropArea: draggableInEachDropArea.slice(), // shallow copy array
			numDraggablesInEachRow: this.tryJSONParse(
				this.model.numDraggablesInEachRow
			),
		};
	}

	getCachedResponseSignal(data) {
		return {
			draggableInEachDropArea: data.draggableInEachDropArea,
		};
	}

	onRenderResponse($responseDiv) {
		let response, preview;
		if (
			this.answerKey === "dropAreaColonDraggableList" ||
			this.answerKey === "draggableInEachDropArea"
		) {
			response = this.driverOutputs[this.answerKey] || "[]";
		}
		if (
			this.previewKey === "dropAreaColonDraggableList" ||
			this.previewKey === "draggableInEachDropArea"
		) {
			preview = this.driverOutputs[this.previewKey] || "[]";
		}

		return new Promise((resolve) => {
			this.clearButtonIsEnabled = !this.isResponseInitial();
			this.rerenderClearButton();

			const responseIsEmpty = this.isResponseEmpty(response);
			if (this.previewKey !== "noPreview") {
				if (responseIsEmpty) {
					$responseDiv.html("<em>No draggables dropped.</em>");
				} else {
					$responseDiv.text(preview);
				}
			}
			this.setSubmittable(
				this.isResponseSubmittable(response, responseIsEmpty)
			);
			resolve();
		});
	}

	/**
	 * Mathjax-type problems require all submittable fields to be filled in.
	 * @param {*} response Driver output of answerKey.
	 * @param {boolean} responseIsEmpty Prevents running the function twice in a row.
	 */
	isResponseSubmittable(response, responseIsEmpty) {
		if (response === undefined) {
			return false;
		} else if (!responseIsEmpty) {
			const numDropAreas = (this.model.mathjax.match(/\\dragdrop{/g) || [])
				.length;
			if (this.answerKey === "draggableInEachDropArea") {
				// Check if all areas have draggables in them.
				for (let i = 0; i < response.length; i++) {
					if (response[i] === -1 || response[i] === undefined) {
						return false;
					}
				}
				return response.length === numDropAreas;
			} else if (this.answerKey === "dropAreaColonDraggableList") {
				return (
					Object.keys(response).length === numDropAreas &&
					response.every((val) => val.slice(-2) !== "-1")
				);
			}
		}
		return false;
	}

	isResponseEmpty(response) {
		if (this.answerKey === "draggableInEachDropArea") {
			if (response) {
				return response.every((val) => val === -1);
			}
			return !response || response.length === 0;
		} else if (this.answerKey === "dropAreaColonDraggableList") {
			return (
				!response ||
				response.length === 0 ||
				response.every((val) => val.slice(-2) === "-1") // -1 is the null draggable index
			);
		}
	}

	isResponseInitial() {
		if (this.driverOutputs["draggableInEachDropArea"]) {
			const respDIEDA = this.driverOutputs["draggableInEachDropArea"];
			const modelDIEDA = this.tryJSONParse(this.model.draggableInEachDropArea);
			if (modelDIEDA) {
				return respDIEDA.every((v, i) => modelDIEDA[i] === v);
			} else {
				return this.isResponseEmpty(this.driverOutputs[this.answerKey]);
			}
		} else {
			return true;
		}
	}
}
